import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from 'grab-ui';

import css from './faq.less';
import {
  sendGAFaqEvent,
  FaqClickEventDataCreator,
} from '../../common/utils/google-analytics-helper';

class FaqItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick() {
    const { isOpen } = this.state;
    const { currentStatus, title, orderID, orderType, senderID } = this.props;
    const event = currentStatus || null;
    sendGAFaqEvent(
      FaqClickEventDataCreator(event, title, orderID, orderType, senderID),
    );
    this.setState({ isOpen: !isOpen });
  }

  handleKeyDown(e) {
    const { isOpen } = this.state;
    if (e.keyCode === 13) {
      this.setState({ isOpen: !isOpen });
    }
  }

  render() {
    const { isOpen } = this.state;
    const { title = '', content = '' } = this.props;
    const getArrowClass = isOpen
      ? 'grabicon-arrow-down'
      : 'grabicon-arrow-forward-01';

    return (
      /*
      Note:
      Disabling lint here because it does not agree that divs apply to the
      keydown rule (it wants a button, etc) but this does not match our use case.
      */
      /* eslint-disable */
      <li
        tabIndex="0"
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        className={classnames([css.item], { [css.isOpen]: isOpen })}
      >
        <Icon type={getArrowClass} />
        <div className={css.content}>
          <h4>{title}</h4>
          <div className={css.answer}>
            <p>{content}</p>
          </div>
        </div>
      </li>
    );
    /* eslint-enable */
  }
}

FaqItem.defaultProps = {
  currentStatus: null,
  orderID: null,
  orderType: null,
  senderID: null,
};

FaqItem.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  orderID: PropTypes.string,
  orderType: PropTypes.string,
  senderID: PropTypes.number,
  currentStatus: PropTypes.string,
};

export default FaqItem;
